import { beforeAuthGuard } from "@/features/auth/guards";
import { SettingsLayoutContainer } from "@/features/settings-layout/containers/settings-layout-container";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/settings")({
  beforeLoad: beforeAuthGuard,
  component: SettingsLayoutContainer,
});
